export default __webpack_public_path__ + "static/media/promo-trends-graph.2dbd2f9a.png";